import { useState } from 'react'
import Model from '../utils/Model';
import { connect } from 'react-redux';
import { closeSignup } from '../../actions'
import SignupModelContentWrapper from './SignUpModelContentWrapper'
// import SignUpHeader from './SignUpHeader'
// import SignUpOne from './SignUpOne'
// import SignUpTwo from './SignUpTwo'
// import SignUpThree from './SignUpThree'
// import ProfileAvatarUpdate from './ProfileAvatarUpdate';
const Signup = (props) => {
    // const [signup, setSignup] = useState({otpSend: false, otpVerified: false, profilePicUpdated: false, number: null, otp: null, password: ""})
    // const [header, setHeader] = useState({title: "", subtitle: ""})
    const [modelheaderText, setModelHeaderText] = useState('Create Account')
    const closeSignup = () => {
        props.closeSignup()
    }
    
    return(
        <Model header={modelheaderText} active={props.modelActive} closeModel={closeSignup}>
            {/* {!signup.otpSend || !signup.otpVerified ? <SignUpHeader title={header.title} subtitle={header.subtitle} /> : ""}
            {!signup.otpSend && !signup.otpVerified ? <SignUpOne closeSignup={closeSignup} signUpSettings={setSignup} setSignUpHeader={setHeader}/> : ""}
            {signup.otpSend && !signup.otpVerified ? <SignUpTwo signUpSettings={setSignup} setSignUpHeader={setHeader} forNumber={signup.number}/> : ""}
            {signup.otpSend && signup.otpVerified && !signup.profilePicUpdated ?<ProfileAvatarUpdate signUpstate={signup} setSignUpstate={setSignup}/> : ""}
            {signup.otpSend && signup.otpVerified && signup.profilePicUpdated ? <SignUpThree signUpstate={signup} closeModel={closeSignup}/>  : ""} */}
            <SignupModelContentWrapper closeSignup={closeSignup} setModelHeaderText={setModelHeaderText}/>
        </Model>
    )
}

const mapStateToProps = (state) => {
    return {
        modelActive: state.signUp
    }
}
export default connect(mapStateToProps, { closeSignup })(Signup)